var exports = {
  "k": "x31de4314--5697c2--container",
  "P": "x31de4314--5697c2--label",
};

module.exports = exports;
